import React, { useState, useEffect, useRef } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as user from "../../utils/user.js";
import * as navigation from "../../utils/navigation.js";
import CustomKeyboard from "./Keyboard";

const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [currentInput, setCurrentInput] = useState("");
  const [newValue, setNewValue] = useState("");
  const inputRef = useRef(null);
  const formRef = useRef(null);
  const keyboardRef = useRef(null);

  if (globalVars.auth.loggedIn) {
    if (!globalVars.mobile) {
      navigation.changePage("home");
    } else {
      navigation.changePage("homeMobile");
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (keyboardRef.current && !keyboardRef.current.contains(event.target)) {
        setKeyboardOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await user.login(e, username, password, setFeedbackMessage);
    if (success) {
      if (!globalVars.mobile) {
        navigation.changePage("home");
      } else {
        navigation.changePage("homeMobile");
      }
    }
    setUsername("");
    setPassword("");
    setKeyboardOpen(false);
    setNewValue("");
  };

  const handleInputFocus = (inputName) => {
    setNewValue("");
    setCurrentInput(inputName);
    setKeyboardOpen(true);
    setNewValue(inputName === "username" ? username : "");
    if (inputName === "password") {
      setNewValue("");
    }
  };

  const handleInputChange = (value) => {
    setNewValue(value);
    if (currentInput === "username") {
      setUsername(value);
    } else if (currentInput === "password") {
      setPassword(value);
    }
  };

  const handleEnter = () => {
    setKeyboardOpen(false);
    setNewValue("");
  };

  // Check if "/keyboard" is in the URL to show the keyboard
  const url = window.location.href;
  const showKeyboard = url.includes("/keyboard");

  return (
    <div
      style={{
        ...props.style, // Take width and height from props.style
        backgroundColor: "#2c2c2c", // Darker background for consistency
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Darker shadow for depth
        alignItems: "center",
        justifyContent: "center", // Ensure content is centered
        padding: "20px", // Padding inside the container
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%", // Full width as per props
          maxWidth: "500px", // Max width for large screens
        }}
        ref={formRef}
      >
        <input
          type="text"
          list="usernames"
          value={username}
          onFocus={() => handleInputFocus("username")}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          style={{
            margin: "10px 0",
            padding: "10px",
            width: "100%",
            borderRadius: "5px",
            border: "1px solid #666", // Darker border for modern feel
            backgroundColor: "#444", // Darker input background
            color: "#fff", // White text for better contrast
            fontSize: "14px",
          }}
          ref={inputRef}
        />
        <datalist id="usernames">
          {globalVars.users.map((user) => (
            <option key={user} value={user} />
          ))}
        </datalist>
        <input
          type="password"
          value={password}
          onFocus={() => handleInputFocus("password")}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={{
            margin: "10px 0",
            padding: "10px",
            width: "100%",
            borderRadius: "5px",
            border: "1px solid #666",
            backgroundColor: "#444",
            color: "#fff",
            fontSize: "14px",
          }}
        />
        <button
          type="submit"
          style={{
            margin: "10px 0",
            padding: "10px",
            width: "100%",
            backgroundColor: "#007bff", // Consistent button color
            color: "#fff", // White text for contrast
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s ease", // Smooth hover transition
          }}
        >
          Login
        </button>
        {feedbackMessage && (
          <p
            style={{
              color: feedbackMessage.includes("error") ? "red" : "green",
              textAlign: "center", // Center the feedback message
            }}
          >
            {feedbackMessage}
          </p>
        )}
      </form>
      <div ref={keyboardRef}>
        {showKeyboard && (
          <CustomKeyboard
            type="text"
            newValue={newValue}
            setNewValue={handleInputChange}
            onEnter={handleEnter}
            showKeyboard={keyboardOpen}
          />
        )}
      </div>
    </div>
  );
};

export default Login;
